// Runtime config for the StoreFront web SPA.
//
// Same-origin in production: the deployed SPA sits behind the edge Caddy,
// which reverse-proxies /auth/* and /v1/* to the Nexus instance on the same
// origin and stamps x-nexus-app-key server-side. Same-origin = no CORS, and
// the app key never ships in the bundle. Local dev can set VITE_GATEWAY_BASE;
// vite.config also proxies /v1 and /auth.

export const APP_ID = 'storefront' as const;

export const GATEWAY_BASE: string =
  (import.meta.env.VITE_GATEWAY_BASE as string | undefined)?.replace(/\/+$/, '') ?? '';

export function appFnUrl(name: string): string {
  return `${GATEWAY_BASE}/v1/app/${APP_ID}/fn/${name}`;
}

/** Stripe merchant country for the Payment Element (mirrors the iOS app). */
export const MERCHANT_COUNTRY = 'US';
